(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6344],{

/***/ 30986:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'phone';
var width = 512;
var height = 512;
var aliases = [128222,128379];
var unicode = 'f095';
var svgPathData = 'M164.9 24.6c-7.7-18.6-28-28.5-47.4-23.2l-88 24C12.1 30.2 0 46 0 64C0 311.4 200.6 512 448 512c18 0 33.8-12.1 38.6-29.5l24-88c5.3-19.4-4.6-39.7-23.2-47.4l-96-40c-16.3-6.8-35.2-2.1-46.3 11.6L304.7 368C234.3 334.7 177.3 277.7 144 207.3L193.3 167c13.7-11.2 18.4-30 11.6-46.3l-40-96z';

exports.DF = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.j1 = exports.DF;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = aliases;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;
__webpack_unused_export__ = aliases;

/***/ }),

/***/ 21653:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var source = __webpack_require__(31255);
exports.DF = {
  prefix: source.prefix,
  iconName: source.iconName,
  icon: [
    source.width,
    source.height,
    source.aliases,
    source.unicode,
    source.svgPathData
  ]};

exports.db = exports.DF;
__webpack_unused_export__ = source.prefix;
__webpack_unused_export__ = source.iconName;
__webpack_unused_export__ = source.width;
__webpack_unused_export__ = source.height;
__webpack_unused_export__ = source.aliases;
__webpack_unused_export__ = source.unicode;
__webpack_unused_export__ = source.svgPathData;
__webpack_unused_export__ = source.aliases;

/***/ }),

/***/ 31255:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
var prefix = 'fal';
var iconName = 'square-arrow-right';
var width = 448;
var height = 512;
var aliases = ["arrow-square-right"];
var unicode = 'f33b';
var svgPathData = 'M416 96c0-17.7-14.3-32-32-32L64 64C46.3 64 32 78.3 32 96l0 320c0 17.7 14.3 32 32 32l320 0c17.7 0 32-14.3 32-32l0-320zM384 32c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l320 0zM347.3 267.3l-96 96c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L297.4 272 112 272c-8.8 0-16-7.2-16-16s7.2-16 16-16l185.4 0-68.7-68.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l96 96c6.2 6.2 6.2 16.4 0 22.6z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faSquareArrowRight = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;

/***/ }),

/***/ 42160:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cities/[...cities]",
      function () {
        return __webpack_require__(27453);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 19435:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/brakes.b89a9927.svg","height":65,"width":60});

/***/ }),

/***/ 92695:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/calendar-icon.a0c1c9de.svg","height":58,"width":54});

/***/ }),

/***/ 51198:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/get-quote.706781f2.svg","height":59,"width":60});

/***/ }),

/***/ 8617:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ AboutPageTitleSection; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _public_img_nubrakes_brake_repair_header_jpeg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12535);
/* harmony import */ var _BgImage__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(63549);




var AboutPageTitleSection = function(param) {
    var title = param.title, description = param.description, bgImageOverride = param.bgImageOverride;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
        className: "py-0",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_BgImage__WEBPACK_IMPORTED_MODULE_3__/* .BgImage */ .D, {
            src: _public_img_nubrakes_brake_repair_header_jpeg__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z || bgImageOverride,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "text-center",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                        className: "title text-white",
                        children: title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        className: "description",
                        children: description
                    })
                ]
            })
        })
    });
};


/***/ }),

/***/ 18132:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z8": function() { return /* binding */ WarningSignsSoundsSection; }
/* harmony export */ });
/* unused harmony exports Warnings, Warning */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var styled_jsx_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(60357);
/* harmony import */ var styled_jsx_style__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(styled_jsx_style__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var ramda__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(61275);
/* harmony import */ var _Container__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(3210);
/* harmony import */ var _LandingPageButton__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(17743);






var WarningSignsSoundsSection = function(param) {
    var title = param.title, subheading = param.subheading, formalMakeName = param.formalMakeName;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_Container__WEBPACK_IMPORTED_MODULE_4__/* .Container */ .W, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                    style: {
                        fontSize: "24px",
                        fontWeight: 900
                    },
                    className: "jsx-bad3bc23d5561c1f",
                    children: title
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    className: "jsx-bad3bc23d5561c1f",
                    children: subheading
                }),
                (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((styled_jsx_style__WEBPACK_IMPORTED_MODULE_1___default()), {
                    id: "bad3bc23d5561c1f",
                    children: "p.jsx-bad3bc23d5561c1f{color:#f04e23;font-size:50px}"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Warnings, {
                    formalMakeName: formalMakeName
                })
            ]
        })
    });
};
var Warnings = function(param) {
    var formalMakeName = param.formalMakeName;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "grid md:grid-cols-3 gap-2",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Warning, {
                warning: "Grinding, Screeching, Squealing, Rubbing, and Other High-Pitched Noises",
                description: "High-pitched noises during the braking process likely means you’re dealing with worn out brake pads and shoes. Continuing to drive with worn out pads and shoes can cause further damage to your vehicle if left unattended, so make sure to schedule a brake inspection ASAP."
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Warning, {
                warning: "Vibration or Pulsing",
                description: "If you feel vibrations or pulsing in the brake pedal or steering wheel during the process of braking, you’re probably dealing with rotor issues. Warped or damaged rotors can lead to a costly repair bill, so get your vehicle checked as soon as you start feeling the sensation."
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Warning, {
                warning: "Excessive Brake Pedal Travel",
                description: "If you feel like your pedal travels further than it should when pushing on the brakes, you’re likely feeling the beginning of brake pad issues. This is the ideal time to get your brakes inspected and repaired, as you’re less likely to have extensive damage."
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Warning, {
                warning: "Grinding, Screeching, Squealing, Rubbing, and Other High-Pitched Noises",
                description: "High-pitched noises during the braking process likely means you’re dealing with worn out brake pads and shoes. Continuing to drive with worn out pads and shoes can cause further damage to your vehicle if left unattended, so make sure to schedule a brake inspection ASAP."
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Warning, {
                warning: "Vibration or Pulsing",
                description: "If you feel vibrations or pulsing in the brake pedal or steering wheel during the process of braking, you’re probably dealing with rotor issues. Warped or damaged rotors can lead to a costly repair bill, so get your vehicle checked as soon as you start feeling the sensation."
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Warning, {
                warning: "Schedule A Free Brake Inspection & Estimate For Your ".concat(formalMakeName),
                showButton: true,
                description: "If you are experiencing any problematic symptoms, schedule a free inspection and estimate from our Dallas brake techs.",
                buttonText: "Free ".concat(formalMakeName, " Brake Service Estimate")
            })
        ]
    });
};
var Warning = function(param) {
    var warning = param.warning, description = param.description, showButton = param.showButton, buttonText = param.buttonText;
    var warningStyles = {
        padding: "20px 20px"
    };
    var orangeWarningStyles = {
        border: "1px solid #ead1ca",
        background: "#ffeee7"
    };
    var styles = showButton ? (0,ramda__WEBPACK_IMPORTED_MODULE_3__/* .mergeRight */ .ATH)(warningStyles, orangeWarningStyles) : warningStyles;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        style: styles,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                style: {
                    fontSize: "18px",
                    fontWeight: 600,
                    lineHeight: "1.33",
                    color: "#1a1919"
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                    children: warning
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                style: {
                    color: "#818b92"
                },
                children: description
            }),
            showButton && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "text-center",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_LandingPageButton__WEBPACK_IMPORTED_MODULE_5__/* .LandingPageButton */ .K, {
                    buttonText: buttonText
                })
            })
        ]
    });
};


/***/ }),

/***/ 96729:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ CitiesCTA; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _Button__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(68663);
/* harmony import */ var _hooks_useQueryParam__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(73401);
/* harmony import */ var _utils_string_utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(2638);







var CitiesCTA = function(param) {
    var _phoneNumber = param.phoneNumber, phoneNumber = _phoneNumber === void 0 ? "8558005629" : _phoneNumber, className = param.className;
    var query = (0,_hooks_useQueryParam__WEBPACK_IMPORTED_MODULE_5__/* .useQueryParam */ .W)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("flex flex-col items-center", className),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "text-center w-full",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                    href: {
                        pathname: "/get-quote/",
                        query: query
                    },
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Button__WEBPACK_IMPORTED_MODULE_4__/* .Button */ .zx, {
                            className: "w-full block sm:w-auto sm:inline py-2 px-6",
                            children: "GET A QUOTE"
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "mt-3",
                children: [
                    "Or call us at ",
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                        href: "tel:".concat(phoneNumber),
                        children: (0,_utils_string_utils__WEBPACK_IMPORTED_MODULE_6__/* .formatPhoneNumber */ .u)(phoneNumber)
                    })
                ]
            })
        ]
    });
};


/***/ }),

/***/ 87762:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "s": function() { return /* binding */ FastAndReliableSection; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _Container__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3210);



var FastAndReliableSection = function(param) {
    var title = param.title;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
        className: "text-center pt-0",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_Container__WEBPACK_IMPORTED_MODULE_2__/* .Container */ .W, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                    className: "title",
                    children: title || "FAST AND RELIABLE BRAKE REPAIR"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                    className: "description text-xl",
                    children: [
                        "Experience fast and reliable brake repair you can trust, confidently backed by over",
                        " ",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("b", {
                            children: "15,000 five-star Google Reviews"
                        }),
                        " from satisfied customers. At Nubrakes, we understand that your brakes are your car's most important safety feature. That's why we take care of them like they're our own. Our skilled technicians use only high-quality parts and equipment to ensure you get the best brake repair possible."
                    ]
                })
            ]
        })
    });
};


/***/ }),

/***/ 55779:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "c": function() { return /* binding */ HowItWorksSection; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _Container__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3210);
/* harmony import */ var _LandingPageButton__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(17743);






var HowItWorksSection = function(param) {
    var title = param.title, description = param.description, steps = param.steps, buttonText = param.buttonText;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
        className: "text-center",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_Container__WEBPACK_IMPORTED_MODULE_3__/* .Container */ .W, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                    style: {
                        fontSize: 40,
                        color: "black",
                        fontWeight: 700
                    },
                    children: title
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    className: "pb-2",
                    style: {
                        color: "#7c7c7c"
                    },
                    children: description
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "grid md:grid-cols-3",
                    style: {
                        boxShadow: "0 13px 27px -5px rgba(50, 50, 93, .25), 0 8px 16px -8px rgba(0, 0, 0, .3), 0 -6px 16px -6px rgba(0, 0, 0, .025)"
                    },
                    children: steps.map(function(value, index) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(HowItWorksStep, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, value), index);
                    })
                }),
                buttonText && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "pt-5",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_LandingPageButton__WEBPACK_IMPORTED_MODULE_4__/* .LandingPageButton */ .K, {
                        buttonText: buttonText
                    })
                })
            ]
        })
    });
};
var HowItWorksStep = function(param) {
    var title = param.title, description = param.description, image = param.image;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "flex flex-grow flex-col h-100 px-5",
        style: {
            backgroundColor: "white",
            border: "1px solid rgb(220, 219, 219)",
            paddingTop: "75px",
            paddingBottom: "75px"
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                src: image,
                width: 60,
                height: 60,
                alt: title,
                className: "mx-auto"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "mt-auto",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                        style: {
                            paddingTop: "20px",
                            fontSize: "18px",
                            fontWeight: 900
                        },
                        children: title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        className: "description m-0",
                        children: description
                    })
                ]
            })
        ]
    });
};


/***/ }),

/***/ 97102:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ ServicesSection; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(828);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var ramda__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(61275);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _Navbar__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(97134);
/* harmony import */ var _Container__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(3210);







var servicesArray = Object.values(_Navbar__WEBPACK_IMPORTED_MODULE_4__/* .services */ .uZ);
var brakeRepairServices = [];
var generalMaintenanceServices = [];
var otherServices = [];
servicesArray.forEach(function(service) {
    if (service.groupName === "Brake Services") {
        brakeRepairServices.push(service);
    } else if (service.groupName === "General Maintenance" || service.groupName === "Lights") {
        generalMaintenanceServices.push(service);
    } else {
        otherServices.push(service);
    }
});
var otherServicesGroups = Object.entries(ramda__WEBPACK_IMPORTED_MODULE_2__/* .groupBy */ .vMG(function(service) {
    return service.groupName;
}, otherServices));
var ServicesSection = function(param) {
    var cityName = param.cityName, className = param.className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
        className: classnames__WEBPACK_IMPORTED_MODULE_3___default()("pt-0 pb-0", className),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_Container__WEBPACK_IMPORTED_MODULE_5__/* .Container */ .W, {
            className: "text-center",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h2", {
                    children: [
                        cityName ? "".concat(cityName, " ") : "",
                        "BRAKE REPAIR SERVICES"
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    className: "description mb-4 pb-0",
                    children: "We offer Top Notch Brake Repair Services, choose one that you want to be delivered right on your door steps."
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                    className: "list-none m-0 p-0 flex flex-wrap",
                    children: brakeRepairServices.map(function(service) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                            className: "w-full ml-0 mb-2 sm:w-1/2",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                href: service.link,
                                children: service.linkTitle
                            })
                        }, service.link);
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h2", {
                    className: "mt-8",
                    children: [
                        cityName ? "".concat(cityName, " ") : "",
                        "GENERAL MAINTENANCE"
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    className: "description mb-4 pb-0",
                    children: "Nubrakes: Your Trusted Brake Specialists, Committed to Comprehensive Auto Care Solutions for Unmatched Performance and Customer Satisfaction."
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                    className: "list-none m-0 p-0 flex flex-wrap ",
                    children: generalMaintenanceServices.map(function(service) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                            className: "w-full ml-0 mb-2 sm:w-1/2",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                href: service.link,
                                className: "text-lg",
                                children: service.linkTitle
                            })
                        }, service.link);
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "flex flex-wrap justify-center mt-4",
                    children: otherServicesGroups.map(function(param) {
                        var _param = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(param, 2), groupName = _param[0], groupServices = _param[1];
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "w-full sm:w-1/2 p-2",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                    children: groupName
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                                    className: "list-none m-0 p-0",
                                    children: groupServices.map(function(service) {
                                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                            className: "mb-4",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                href: service.link,
                                                children: service.linkTitle
                                            })
                                        }, service.link);
                                    })
                                })
                            ]
                        }, groupName);
                    })
                })
            ]
        })
    });
};


/***/ }),

/***/ 59622:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _builder_io_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(18202);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _components_Layout__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(22932);
/* harmony import */ var _components_Container__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(3210);
/* harmony import */ var _components_AboutPageTitleSection__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(8617);







var NotFoundPage = function() {
    if (_builder_io_react__WEBPACK_IMPORTED_MODULE_2__/* .Builder.isPreviewing */ .Ib.isPreviewing || _builder_io_react__WEBPACK_IMPORTED_MODULE_2__/* .Builder.isEditing */ .Ib.isEditing) {
        // Protect from 404s in preview or edit mode on live URLs
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_builder_io_react__WEBPACK_IMPORTED_MODULE_2__/* .BuilderComponent */ .VD, {
            model: "page"
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_Layout__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        title: "Whoops...",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_3___default()), {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "robots",
                    content: "noindex,nofollow"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_AboutPageTitleSection__WEBPACK_IMPORTED_MODULE_6__/* .AboutPageTitleSection */ .P, {
                title: "Oops... It looks like you made a wrong turn..."
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                className: "text-center",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_Container__WEBPACK_IMPORTED_MODULE_5__/* .Container */ .W, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                            children: "Need Immediate Help?"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "description",
                            children: "We strive to provide you with quality, hassle-free brake repair services and stand behind our work. We’re preparing your repair quote, but if you’d like immediate assistance or already know you’d like to set up service, don’t hesitate to call us."
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "description",
                            children: "Call now to speak with our brake team."
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            href: "tel:8558005629",
                            style: {
                                fontSize: 30
                            },
                            children: "(855) 800-5629"
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (NotFoundPage);


/***/ }),

/***/ 27453:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ _cities_; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@builder.io/react/dist/builder-react.es5.js
var builder_react_es5 = __webpack_require__(18202);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/components/LoadingIndicator.tsx
var LoadingIndicator = __webpack_require__(73803);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./src/pages/404.tsx
var _404 = __webpack_require__(59622);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/CarPage/WarningSignsSoundsSection.tsx
var WarningSignsSoundsSection = __webpack_require__(18132);
// EXTERNAL MODULE: ./src/components/CarPage/FAQSection.tsx
var FAQSection = __webpack_require__(6550);
// EXTERNAL MODULE: ./src/components/utils/string-utils.ts
var string_utils = __webpack_require__(2638);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./src/components/Layout.tsx + 1 modules
var Layout = __webpack_require__(22932);
// EXTERNAL MODULE: ./src/components/FeatureBySection.tsx + 4 modules
var FeatureBySection = __webpack_require__(97257);
// EXTERNAL MODULE: ./src/components/LandingPage/HowItWorksSection.tsx
var HowItWorksSection = __webpack_require__(55779);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./src/components/Container.tsx
var Container = __webpack_require__(3210);
// EXTERNAL MODULE: ./src/components/GraySection.tsx
var GraySection = __webpack_require__(18737);
;// CONCATENATED MODULE: ./src/components/LandingPage/ConvenientAffordableSection.tsx








var ConvenientAffordableSection = function(param) {
    var title = param.title, description = param.description, reasons = param.reasons;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(GraySection/* GraySection */.g, {
        className: "text-center",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* Container */.W, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                    className: "title",
                    children: title
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "description",
                    children: description
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "grid md:grid-cols-3 gap-4",
                    children: reasons.map(function(item, index) {
                        return /*#__PURE__*/ (0,react.createElement)(ConvenienceReason, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, item), {
                            key: index
                        }));
                    })
                })
            ]
        })
    });
};
var ConvenienceReason = function(param) {
    var icon = param.icon, title = param.title, description = param.description;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: {
                    height: 65,
                    width: "100%",
                    position: "relative"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    src: icon,
                    layout: "fill",
                    objectFit: "contain",
                    className: "mx-auto"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                style: {
                    paddingTop: "20px",
                    fontSize: "18px",
                    fontWeight: 600,
                    lineHeight: "1.33",
                    color: "#1a1919"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                    children: title
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "description",
                children: description
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/components/SEMPage/ReviewsSection.tsx + 4 modules
var ReviewsSection = __webpack_require__(94014);
// EXTERNAL MODULE: ./src/components/HappinessGuaranteeSection.tsx
var HappinessGuaranteeSection = __webpack_require__(28763);
// EXTERNAL MODULE: ./src/components/LandingPage/BrakeRepairNearYouWithCities.tsx
var BrakeRepairNearYouWithCities = __webpack_require__(61042);
// EXTERNAL MODULE: ./src/components/Builder/components/CarBrandGrid.tsx
var CarBrandGrid = __webpack_require__(65105);
// EXTERNAL MODULE: ./src/components/CityPage/FastAndReliableSection.tsx
var FastAndReliableSection = __webpack_require__(87762);
// EXTERNAL MODULE: ./src/components/ServicesSection.tsx
var ServicesSection = __webpack_require__(97102);
// EXTERNAL MODULE: ./src/components/CityPage/CitiesCTA.tsx
var CitiesCTA = __webpack_require__(96729);
// EXTERNAL MODULE: ./node_modules/styled-jsx/style.js
var style = __webpack_require__(60357);
var style_default = /*#__PURE__*/__webpack_require__.n(style);
;// CONCATENATED MODULE: ./public/img/nubrakes-warranty.png
/* harmony default export */ var nubrakes_warranty = ({"src":"/_next/static/media/nubrakes-warranty.bff336a5.png","height":512,"width":512,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAIVBMVEUAAAAAAAAAAAAAAAAAAAAAAAAAAABMaXEAAAAAAAAAAABqqvSrAAAAC3RSTlN5K29khko/AE8aAa4pC78AAAAJcEhZcwAADsQAAA7EAZUrDhsAAAA2SURBVHicLcqxEcAwDMNAkIxk2fsPnIsvqL4Az02LGFw/on1RPS0GMkffEJfayCTasFRdPXoBHhsA3DVUIp4AAAAASUVORK5CYII=","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./public/img/time-icon@3x.png
/* harmony default export */ var time_icon_3x = ({"src":"/_next/static/media/time-icon@3x.14fa931f.png","height":213,"width":204,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAIVBMVEUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABt0UjBAAAAC3RSTlMBSz4MHzRXhBJpr4wRCcUAAAAJcEhZcwAACxMAAAsTAQCanBgAAAA1SURBVHicLcvJDcAwEAOxkbSHnf4LDgLkTwLsU2mgqrwXSoBNJHQZLPcehsgJR7/Rt9Ke5gUZ3ACuWyGoowAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./src/components/CarPage/V2BookFactsSection.tsx








var V2BookFactsSection = function(param) {
    var title = param.title, subheading1 = param.subheading1, subheading2 = param.subheading2, paragraphs = param.paragraphs;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(GraySection/* GraySection */.g, {
        className: "text-center",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* Container */.W, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                    className: "jsx-29183d82a2db429c" + " " + "title",
                    children: title
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "jsx-29183d82a2db429c" + " " + "description",
                    children: subheading1
                }),
                (0,jsx_runtime.jsx)((style_default()), {
                    id: "29183d82a2db429c",
                    children: ".facts-block{background-color:white;border:1px solid rgb(234,209,202)}.small-header{font-size:18px;font-weight:800;line-height:1.33;color:#1a1919}"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "jsx-29183d82a2db429c" + " " + "grid lg:grid-cols-12",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "jsx-29183d82a2db429c" + " " + "lg:col-span-8 facts-block",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FactsPane, {
                                shpealTitle: subheading2,
                                paragraphs: paragraphs
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "jsx-29183d82a2db429c" + " " + "lg:col-span-4 facts-block",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FactsSideBar, {})
                        })
                    ]
                })
            ]
        })
    });
};
var FactsPane = function(param) {
    var shpealTitle = param.shpealTitle, paragraphs = param.paragraphs;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "text-left p-12",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                children: shpealTitle
            }),
            paragraphs && paragraphs.map(function(p, index) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "description",
                    children: p
                }, index);
            })
        ]
    });
};
var FactsSideBar = function() {
    var FactsSideBarItem = function(param) {
        var title = param.title, description = param.description, image = param.image;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "text-center",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    src: image,
                    width: 50,
                    height: 50,
                    alt: title,
                    className: "mx-auto"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                    className: "small-header",
                    children: title
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    children: description
                })
            ]
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "p-12",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "pb-3",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: "small-header mb-0",
                        children: "Additional Perks"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: "small-header",
                        children: "of Choosing NuBrakes"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FactsSideBarItem, {
                title: "Top Rated Warranty",
                description: "Every brake repair comes with our NuBrakes Guarantee.",
                image: nubrakes_warranty
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FactsSideBarItem, {
                title: "On-Demand Service",
                description: "We make sure to work around your schedule, not against it.",
                image: time_icon_3x
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/components/SEMPage/CityPhoneNumberData.tsx
var CityPhoneNumberData = __webpack_require__(21611);
// EXTERNAL MODULE: ./public/img/get-quote.svg
var get_quote = __webpack_require__(51198);
// EXTERNAL MODULE: ./public/img/calendar-icon.svg
var calendar_icon = __webpack_require__(92695);
// EXTERNAL MODULE: ./public/img/brakes.svg
var brakes = __webpack_require__(19435);
;// CONCATENATED MODULE: ./public/img/technicians@3x.png
/* harmony default export */ var technicians_3x = ({"src":"/_next/static/media/technicians@3x.f9f06023.png","height":219,"width":216,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAIVBMVEUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABt0UjBAAAAC3RSTlNqYBSJRXsDVSMzKQ+rxsYAAAAJcEhZcwAACxMAAAsTAQCanBgAAAA0SURBVHicBcGJAcAgDMQw3xMC3X/gSuhUqg8uwB6uwoaLhSQenkwGU94kNZU3sbn9mJ79ARsKANXWRG/nAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./public/img/brake-van.png
/* harmony default export */ var brake_van = ({"src":"/_next/static/media/brake-van.bd25d4b1.png","height":128,"width":274,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAMAAACEE47CAAAAIVBMVEVbW11XV1hYWFtXV1lXV1pYWFlZWVpXV1pXV1lYWFpMaXFoe4VnAAAAC3RSTlP9V6syh7xP0JV3AG52vc0AAAAJcEhZcwAACxIAAAsSAdLdfvwAAAAlSURBVHicBcGHAQAwCMMwkzD7/8GVaA1rPyKLCplYDSB82Z3XHwiqAIBuUdajAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":4});
;// CONCATENATED MODULE: ./public/img/brake-rotor.png
/* harmony default export */ var brake_rotor = ({"src":"/_next/static/media/brake-rotor.a17a2c22.png","height":129,"width":128,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAIVBMVEVYWFpYWFpVVV9YWFpYWFtYWFpbW11XV1lYWFpYWFlYWF3ZHKBWAAAAC3RSTlPaowOCzZP6Q7lyF/9cZ9UAAAAJcEhZcwAACxMAAAsTAQCanBgAAAA0SURBVHicBcGHAcBAEMIwA9c++w8cCX9db22+moGYHhLxqEkrVzyibsGidO6w6lQsdgqtfyS4APGJxNZKAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./public/img/customer-service.png
/* harmony default export */ var customer_service = ({"src":"/_next/static/media/customer-service.ab06a133.png","height":130,"width":136,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAJFBMVEVYWFpYWFlPT2NZWV5XV1pYWFpXV1lZWVpYWFpYWFpdXV9WVlwVpGSdAAAADHRSTlOVZQERH4Z4SrZU3CyJgagNAAAACXBIWXMAAAsTAAALEwEAmpwYAAAANElEQVR4nAXBhwEAIAzDMCedwP//IuGs7koTdaRTwaD3xLBM5mG5lRHJBSRpwaFuZGzDhD8mXwDvIcoLGAAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./public/img/warranty.png
/* harmony default export */ var warranty = ({"src":"/_next/static/media/warranty.f829a4e0.png","height":134,"width":100,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAICAMAAADtGH4KAAAAJ1BMVEVcXFhZWVtXV1lYWFpYWFpZWVpYWFhXV1pYWFpMaXFYWFpbW1hYWFpRcuWcAAAADXRSTlMMo7N8TJIcxWoAPCvhuVC8cgAAAAlwSFlzAAALEwAACxMBAJqcGAAAAC9JREFUeJwFwYcBACAMwzCnu8D/9yKBmzl4LuboRkai8wYxOlfDyiyX6u4HVHjUBxZAAOC33ibbAAAAAElFTkSuQmCC","blurWidth":6,"blurHeight":8});
;// CONCATENATED MODULE: ./public/img/open-sign.png
/* harmony default export */ var open_sign = ({"src":"/_next/static/media/open-sign.12e53712.png","height":128,"width":162,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAGCAMAAADJ2y/JAAAAKlBMVEVZWVtWVkRYWFpYWFtXV1pZWVpZWVtZWVpVVVhbW1tZWVpYWFhaWlpZWVqX2774AAAADnRSTlP2AlNv6djIgywcqi4wtHEHI1sAAAAJcEhZcwAACxIAAAsSAdLdfvwAAAAvSURBVHicBcEBAoAgDAOxa7sxQP3/d02QtLckjv289qEBimYlzviyJl8mly6oYv0UIQDF1CrU8gAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":6});
// EXTERNAL MODULE: ./src/components/Builder/components/HeroInline.tsx + 1 modules
var HeroInline = __webpack_require__(70397);
;// CONCATENATED MODULE: ./src/components/CityPage/MajorCityPageTemplate.tsx





















var CityNearYouSection = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 8809).then(__webpack_require__.bind(__webpack_require__, 78809)).then(function(mod) {
        return mod.CityNearYouSection;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(78809)
            ];
        }
    }
});










var MajorCityPageTemplate = function(param) {
    var cityName = param.cityName, stateAbbreviation = param.stateAbbreviation, cities = param.cities, listOfZips = param.listOfZips, listOfMinorCities = param.listOfMinorCities, schemas = param.schemas, metaDescription = param.metaDescription, titleTagTitle = param.titleTagTitle, reviews = param.reviews, phoneNumber = param.phoneNumber, rating = param.rating, reviewCount = param.reviewCount, blobSection = param.blobSection, blobParagraphs = param.blobParagraphs, _carsContent = param.carsContent, carsContent = _carsContent === void 0 ? [] : _carsContent;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Layout/* default */.Z, {
        title: titleTagTitle,
        phoneNumber: "".concat(phoneNumber),
        phoneNumberTxt: (0,string_utils/* formatPhoneNumber */.u)("".concat(phoneNumber)),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: metaDescription ? metaDescription : "Schedule mobile brake repair services in ".concat(cityName, ", ").concat(stateAbbreviation, ". Affordable repairs, no upsells, and insanely good customer service. We come to you!")
                    }),
                    schemas && schemas.map(function(schema, index) {
                        var blob = JSON.stringify(JSON.parse(schema.blob));
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                            type: "application/ld+json",
                            dangerouslySetInnerHTML: {
                                __html: blob
                            }
                        }, index);
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HeroInline/* HomeScheduleServiceFormHeaderInline */.L, {
                title: "The Best Mobile Brake Repair in ".concat(cityName, " — We Come To You."),
                subheading: "Schedule your mobile brake repair today!",
                headerTitle: "Book affordable repairs without leaving your home.",
                subtitle: "Our repair experts will send you a quote in under 5 minutes.",
                rating: rating,
                reviewCount: reviewCount,
                buttonText: "GET A FREE QUOTE",
                isLinkForm: true,
                ratingsText: "customers",
                linkTarget: "get-a-quote/services"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FeatureBySection/* FeatureBySection */.x, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HowItWorksSection/* HowItWorksSection */.c, {
                title: "Skip The ".concat(cityName, " Traffic, We Come To You."),
                description: "Let our ".concat(cityName, " mobile brake repair technicians take care of your brake problems."),
                steps: [
                    {
                        title: "Get Your Free Repair Quote",
                        description: "Let us know what’s going on with your brakes and we’ll send you a free, no obligation repair quote for your vehicle.",
                        image: get_quote/* default */.Z
                    },
                    {
                        title: "Select Your Repair Date",
                        description: "Select a repair date and time that works around your schedule. We pride ourselves on making it simple for you.",
                        image: calendar_icon/* default */.Z
                    },
                    {
                        title: "Enjoy Safer, Better Driving",
                        description: "Our brake technicians will ensure that your brakes are ready to hit the road and get you back to driving worry-free!",
                        image: brakes/* default */.Z
                    }, 
                ],
                buttonText: "Get A Free ".concat(cityName, " Brake Service Estimate")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ConvenientAffordableSection, {
                title: "Convenient & Affordable ".concat(cityName, " Brake Repair"),
                description: "Do you really want to waste time sitting at a brake shop? Our ".concat(cityName, " mobile brake technicians work on your vehicle right where it's parked at your work or home."),
                reasons: [
                    {
                        title: "Save Time & Money",
                        description: "Save up to 40% on average when compared to taking your car to a local auto repair shop.",
                        icon: brake_van
                    },
                    {
                        title: "Experienced Brake Technicians",
                        description: "All of our mobile brake technicians are ASE-certified and able to take care of all your brake repair or replacement needs.",
                        icon: technicians_3x
                    },
                    {
                        title: "Premium Brake Parts",
                        description: "We offer premium brake parts with no markup, something that can’t be said by the big box shops.",
                        icon: brake_rotor
                    },
                    {
                        title: "Unreal Customer Service",
                        description: "Have a question about your brakes before, during or after the service? We’re here to help.",
                        icon: customer_service
                    },
                    {
                        title: "NuBrakes Guarantee",
                        description: "Our repairs are backed by our NuBrakes Guarantee to provide peace of mind. Read our warranty for more information.",
                        icon: warranty
                    },
                    {
                        title: "Available When You Need Us",
                        description: "We want to make brake repairs convenient, so we operate well past the time most traditional shops do.",
                        icon: open_sign
                    }, 
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ReviewsSection/* ReviewsSection */.m2, {
                phoneNumber: phoneNumber || CityPhoneNumberData/* CityPhoneNumberData.default.phoneNumber */.L["default"].phoneNumber,
                rating: rating,
                reviewCount: reviewCount,
                title: "Don't Just Take Our Word For It.",
                description: "Drivers trust NuBrakes to handle their brake needs.",
                reviews: reviews
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(V2BookFactsSection, {
                title: blobSection.title,
                subheading1: blobSection.subheading1,
                subheading2: blobSection.subheading2,
                paragraphs: blobParagraphs
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(WarningSignsSoundsSection/* WarningSignsSoundsSection */.Z8, {
                title: "".concat(cityName, " Brake Problems & Symptoms"),
                subheading: "Warning Signs & Sounds",
                formalMakeName: "Vehicle"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HappinessGuaranteeSection/* HappinessGuaranteeSection */.M, {
                title: "We have a 100% NuBrakes Happiness Guarantee!",
                description: "We want to make the brake repair process simple and frustration-free. If you're not happy with your repair or replacement, we'll do everything we can to fix it. Call or message us any day, any time, and we'll do our best to fix whatever issue you're having."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ServicesSection/* ServicesSection */.$, {
                cityName: cityName,
                className: "pt-12 pb-6 sm:pb-12"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* Container */.W, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CitiesCTA/* CitiesCTA */.B, {
                    phoneNumber: phoneNumber || CityPhoneNumberData/* CityPhoneNumberData.default.phoneNumber */.L["default"].phoneNumber
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "border-b-[1px] border-gray-100 pt-12"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CarBrandGrid/* CarBrandGrid */.Q, {
                title: "We Offer Auto Repair Services On Nearly Every Model in ".concat(cityName),
                carContent: carsContent,
                className: "pt-16",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "mt-6"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FastAndReliableSection/* FastAndReliableSection */.s, {
                title: "FAST AND RELIABLE BRAKE REPAIR IN ".concat(cityName)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FAQSection/* FAQSection */.v, {
                title: "Frequently Asked ".concat(cityName, " Repair Questions"),
                description: "Learn more about our ".concat(cityName, " brake repair operations"),
                faqs: [
                    {
                        question: "How is NuBrakes different from other ".concat(cityName, " brake repairs near me?"),
                        answer: "NuBrakes provides a modern approach to brake repair and replacements by providing an on-demand style service that comes to you. Unlike traditional ".concat(cityName, " brake service shops that require to you to wait in the lobby while the brake repair is being done, use poor quality parts, and lack transparent pricing; NuBrakes will start by sending you a transparent quote, upon your approval, a NuBrakes ASE-certified technician will come to you with everything they need to repair your brakes. We want to save you time and provide you with a trustworthy and transparent diagnosis and repair quote for your ").concat(cityName, ". To request a quote, simply click here, fill out your vehicle information and brake symptoms, and we’ll send you a quote for your ").concat(cityName, " brake service in under an hour.")
                    },
                    {
                        question: "Are your ".concat(cityName, " brake service technicians ASE-certified?"),
                        answer: "Absolutely. Every NuBrakes ".concat(cityName, " brake repair technician has years of industry experience and has been certified by The National Institute for Automotive Service Excellence (ASE). Our technicians have a depth of knowledge in all forms of vehicle repair, but brake repair is our core service and specialty.")
                    },
                    {
                        question: "Why should I choose mobile brake repair?",
                        answer: "We’re a firm believer that your time, energy, and a trustworthy service provider is much more valuable than spending your Saturday afternoon at the brake repair shop. We’ve built the NuBrakes service so that you can efficiently receive a quote and schedule a mobile brake repair service that comes to you, with just a few clicks. There’s not enough time in the day and we think you should spend more time doing what you love and waiting at the brake repair shop is not it. Not to mention, many brake repair shops will quote you more than you need to spend, and often suggest you repair or replace brake parts when it is not necessary. What’s better than saving time and money?"
                    },
                    {
                        question: "What type of brake pads does NuBrakes use?",
                        answer: "High-quality parts are of the utmost importance when repairing your brakes. At NuBrakes, most frequently we are using professional ceramic or semi-metallic brake pads. These parts offer exceptional performance and are backed by our 24 Month/24,000 Mile warranty."
                    },
                    {
                        question: "How long does it take to repair or replace my brakes?",
                        answer: "On average, your mobile brake repair service will take 45-90 minutes, with the average appointment lasting around an hour. If you have any time constraints, we’re happy to coordinate around your schedule."
                    },
                    {
                        question: "What should I expect during my brake repair appointment?",
                        answer: "After you request a free brake repair quote, you’ll receive an email within 1 hour that will outline our best guess (based on the symptoms you provided) for the repairs and estimated cost. On the day of your appointment, a NuBrakes technician will arrive with all the tools they need to evaluate your brakes in person. Following the in-person evaluation, your technician will provide you with a formal repair quote. Upon your approval, the technician will complete the brake repair procedure."
                    },
                    {
                        question: "Do you service all ".concat(cityName, " models?"),
                        answer: "Yes, we’re able to provide brake service on nearly all ".concat(cityName, " models and trims! All of our mobile brake replacement technicians have all of the necessary tools and experience to repair your brakes no matter the model/year. So whether you’re looking for service on a 328i or an M-class, we can take care of your brake service needs.")
                    },
                    {
                        question: "Do you offer a warranty on the brake repairs?",
                        answer: "Yes, your NuBrakes mobile brake repair is backed by our 24 month, 24,000 mile warranty."
                    }, 
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CityNearYouSection, {
                title: "The Best ".concat(cityName, " Mobile Brake Repair Near Me"),
                description: "Stop searching for a local ".concat(cityName, " brake shop near you. We cover most of the ").concat(cityName, " metro area and bring the brake shop to you."),
                listOfZips: listOfZips,
                listOfMinorCities: listOfMinorCities
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BrakeRepairNearYouWithCities/* BrakeRepairNearYouWithCities */.r, {
                title: "We’re the closest mobile brake repair service in ".concat(cityName, " near you. Skip waiting in line at the repair shop, we come to you!"),
                cities: cities
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/@fortawesome/free-solid-svg-icons/faWrench.js
var faWrench = __webpack_require__(88302);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-duotone-svg-icons/index.mjs
var pro_duotone_svg_icons = __webpack_require__(21702);
// EXTERNAL MODULE: ./src/components/LandingPageButton.tsx
var LandingPageButton = __webpack_require__(17743);
// EXTERNAL MODULE: ./public/img/nubrakes-brake-repair-header.jpg
var nubrakes_brake_repair_header = __webpack_require__(57581);
// EXTERNAL MODULE: ./src/components/BgImage.tsx
var BgImage = __webpack_require__(63549);
;// CONCATENATED MODULE: ./src/components/MinorCityTitleSection.tsx






var MinorCityTitleSection = function(param) {
    var title = param.title, subheading = param.subheading, buttonText = param.buttonText;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
            className: "text-white py-0",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BgImage/* BgImage */.D, {
                src: nubrakes_brake_repair_header/* default */.Z,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* Container */.W, {
                    className: "text-center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                            className: "title",
                            children: title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "subheading",
                            children: subheading
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(LandingPageButton/* LandingPageButton */.K, {
                            buttonText: buttonText
                        })
                    ]
                })
            })
        })
    });
};

// EXTERNAL MODULE: ./node_modules/@fortawesome/react-fontawesome/index.es.js
var index_es = __webpack_require__(67814);
;// CONCATENATED MODULE: ./src/components/MinorCitySecondSection.tsx





var MinorCitySecondSection = function(param) {
    var title = param.title, subheading = param.subheading, firstReasonWhy = param.firstReasonWhy, secondReasonWhy = param.secondReasonWhy, thirdReasonWhy = param.thirdReasonWhy;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: "text-center",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* Container */.W, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            className: "title",
                            children: title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            style: {
                                color: "#7c7c7c"
                            },
                            children: subheading
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "grid grid-cols-1 md:grid-cols-3",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ReasonWhyItem, (0,_object_spread/* default */.Z)({}, firstReasonWhy)),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ReasonWhyItem, (0,_object_spread/* default */.Z)({}, secondReasonWhy)),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ReasonWhyItem, (0,_object_spread/* default */.Z)({}, thirdReasonWhy))
                    ]
                })
            ]
        })
    });
};
var ReasonWhyItem = function(param) {
    var title = param.title, subheading = param.subheading, icon = param.icon;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-grow flex-col h-100 py-8",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                    size: "4x",
                    icon: icon,
                    color: "#ea3616"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "mt-auto",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                        style: {
                            paddingTop: 20,
                            fontSize: 18,
                            fontWeight: 900
                        },
                        children: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "m-0",
                        children: subheading
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/@fortawesome/free-solid-svg-icons/faPhone.js
var faPhone = __webpack_require__(30986);
;// CONCATENATED MODULE: ./src/components/ZipsPage/GetImageForRating.tsx
var getImageForRating = function(rating) {
    switch(rating){
        case 0:
            return "/img/yelp-stars/regular_0.png";
        case 1:
            return "/img/yelp-stars/regular_1.png";
        case 1.5:
            return "/img/yelp-stars/regular_1_half.png";
        case 2:
            return "/img/yelp-stars/regular_2.png";
        case 2.5:
            return "/img/yelp-stars/regular_2_half.png";
        case 3:
            return "/img/yelp-stars/regular_3.png";
        case 3.5:
            return "/img/yelp-stars/regular_3_half.png";
        case 4:
            return "/img/yelp-stars/regular_4.png";
        case 4.5:
            return "/img/yelp-stars/regular_4_half.png";
        case 5:
            return "/img/yelp-stars/regular_5.png";
        default:
            return "/img/yelp-stars/regular_5.png";
    }
};

// EXTERNAL MODULE: ./src/components/Button.tsx
var Button = __webpack_require__(68663);
;// CONCATENATED MODULE: ./public/img/yelp-business-placeholder.png
/* harmony default export */ var yelp_business_placeholder = ({"src":"/_next/static/media/yelp-business-placeholder.1a2fc2fd.png","height":90,"width":90,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAACVBMVEXu7u7o6Oj19fVSOYfWAAAACXBIWXMAAAsSAAALEgHS3X78AAAAKElEQVR4nFXLwQ0AMAyDQGD/oaukr/xOWAagCtRF+kvqrIv1QQzmDz0KfQBDBpDd9QAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./src/components/ZipsPage/ListYelpDataSection.tsx









var ListYelpDataSection = function(param) {
    var locationName = param.locationName, businesses = param.businesses, subheading = param.subheading;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* Container */.W, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                        className: "title text-center",
                        children: [
                            "The Top 10 Brake Repair Shops in ",
                            locationName
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "text-center",
                        style: {
                            color: "#a6adb4",
                            fontSize: 22
                        },
                        children: subheading
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {}),
                    businesses && businesses.length > 0 && businesses.map(function(business, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(YelpSectionItem, {
                                    business: business
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {})
                            ]
                        }, index);
                    })
                ]
            })
        })
    });
};
var YelpSectionItem = function(param) {
    var business = param.business;
    var yelpStars = getImageForRating(business.rating);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "grid md:grid-cols-2 py-6",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-row",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "pr-4",
                                children: business.photos && // cant use Image because yelp cdn resolution is unpredictable
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    style: {
                                        width: 70,
                                        height: 70
                                    },
                                    src: business.photos[0] === "https://s3-media3.fl.yelpcdn.com/bphoto/None/o.jpg" ? yelp_business_placeholder : business.photos[0]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                        style: {
                                            fontSize: 18
                                        },
                                        children: business.name
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: yelpStars
                                            }),
                                            " ",
                                            business.review_count,
                                            " Reviews"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        children: [
                                            business.location.address1,
                                            " ",
                                            business.location.city,
                                            " ",
                                            business.location.state
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "text-right flex flex-col justify-center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: "tel:".concat(business.phone),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* YelpButton */.H4, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                        icon: faPhone/* faPhone */.j1,
                                        flip: "horizontal"
                                    }),
                                    " Call Business"
                                ]
                            })
                        })
                    })
                ]
            }),
            business.reviews && business.reviews.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(YelpReviews, {
                reviews: business.reviews
            })
        ]
    });
};
var YelpReviews = function(param) {
    var reviews = param.reviews;
    var ref = (0,react.useState)(true), isHidden = ref[0], setIsHidden = ref[1];
    var reviewsToShow = isHidden ? reviews.slice(0, 1) : reviews;
    var showAll = function() {
        setIsHidden(false);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: reviewsToShow.map(function(review, index) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-row",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: review.user.image_url,
                        style: {
                            height: "30px",
                            width: "30px",
                            borderRadius: "100%",
                            backgroundRepeat: "no-repeat",
                            backgroundPosition: "center center",
                            backgroundSize: "cover",
                            backgroundColor: "#efefef",
                            marginRight: "10px"
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            children: [
                                review.text,
                                " ",
                                isHidden && /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    className: "text-primary",
                                    onClick: showAll,
                                    children: "Show More"
                                })
                            ]
                        })
                    })
                ]
            }, index);
        })
    });
};

// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/hooks/useQueryParam.tsx
var useQueryParam = __webpack_require__(73401);
// EXTERNAL MODULE: ./public/img/nubrakes-brake-repair-header.jpeg
var img_nubrakes_brake_repair_header = __webpack_require__(12535);
// EXTERNAL MODULE: ./node_modules/@fortawesome/free-solid-svg-icons/index.mjs
var free_solid_svg_icons = __webpack_require__(59417);
;// CONCATENATED MODULE: ./src/components/SEMPage/MinorCityFourthSection.tsx









var MinorCityFourthSection = function(param) {
    var title = param.title, subheading = param.subheading;
    var query = (0,useQueryParam/* useQueryParam */.W)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        // not refactoring this one b/c I don't have any way to reproduce examples. Jake let me know that they created major city pages for all minor cities
        className: "full-width-image top-section",
        style: {
            backgroundImage: "url(".concat(img_nubrakes_brake_repair_header/* default.src */.Z.src, ")"),
            backgroundPosition: "top left",
            backgroundAttachment: "fixed"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* Container */.W, {
            className: "text-center",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "grid md:grid-cols-2",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "text-left flex flex-col flex-grow justify-center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                    style: {
                                        fontSize: 29,
                                        color: "white"
                                    },
                                    children: title
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    style: {
                                        color: "#cbd0d3",
                                        fontSize: 16
                                    },
                                    children: subheading
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            style: {
                                padding: "20px 45px"
                            },
                            className: "bg-white",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                    className: "text-black",
                                    children: "Perks of NuBrakes"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Perk, {
                                    perkText: "We Come To You"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Perk, {
                                    perkText: "Save Up To 40% On Average"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Perk, {
                                    perkText: "Zero Markup On Parts — Ever"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Perk, {
                                    perkText: "ASE Certified Brake Techs"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: {
                                        pathname: "/get-quote/",
                                        query: query
                                    },
                                    passHref: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.zx, {
                                        className: "w-full py-2",
                                        style: {
                                            fontSize: 15,
                                            fontWeight: "bold"
                                        },
                                        children: "GET A FREE QUOTE NOW"
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        })
    });
};
var Perk = function(param) {
    var perkText = param.perkText;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-row items-center py-1",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                icon: free_solid_svg_icons/* faCheckCircle */.f8k,
                style: {
                    fontWeight: 100
                },
                color: "#bfbfbf",
                size: "3x"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "pl-3",
                style: {
                    color: "#a6adb4"
                },
                children: perkText
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-light-svg-icons/faArrowSquareRight.js
var faArrowSquareRight = __webpack_require__(21653);
// EXTERNAL MODULE: ./node_modules/ramda/es/index.js + 240 modules
var es = __webpack_require__(61275);
// EXTERNAL MODULE: ./src/util/util.tsx
var util = __webpack_require__(6069);
// EXTERNAL MODULE: ./node_modules/param-case/dist.es2015/index.js + 1 modules
var dist_es2015 = __webpack_require__(34539);
;// CONCATENATED MODULE: ./public/img/united-states.svg
/* harmony default export */ var united_states = ({"src":"/_next/static/media/united-states.58956a94.svg","height":394,"width":622});
;// CONCATENATED MODULE: ./src/components/ServicesPage/OtherCitiesSection.tsx













var OtherCitiesSection = function(param) {
    var mainCities = param.mainCities;
    var query = (0,useQueryParam/* useQueryParam */.W)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* Container */.W, {
            style: {
                maxWidth: 800
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "text-center pb-3",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            children: "Need Brake Services In Another City?"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            className: "w-full mx-auto",
                            alt: "NuBrakes Other Cities Header",
                            src: united_states
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "grid md:grid-cols-3 gap-4",
                    children: (0,es/* pipe */.zGw)((0,es/* take */.qnb)(12), (0,util/* mapIndexed */.XD)(function(city, rowIndex) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "flex flex-row md:justify-end",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                as: {
                                    pathname: "/cities/".concat((0,dist_es2015/* paramCase */.o)(city.cityName), "-brake-repair/"),
                                    query: query
                                },
                                href: "/cities/[slug]",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                    style: {
                                        color: "#a6adb4"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                            className: "pr-3",
                                            children: [
                                                "".concat(city.cityName, ", ").concat(city.stateAbbreviation),
                                                " Brake Repair"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                            size: "lg",
                                            icon: faArrowSquareRight/* faArrowSquareRight */.db,
                                            color: "#a6adb4"
                                        })
                                    ]
                                })
                            })
                        }, rowIndex);
                    }))(mainCities)
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "text-center pt-6",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: {
                            pathname: "/cities/",
                            query: query
                        },
                        passHref: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* ViewAllCitiesButton */.Op, {
                                children: "VIEW ALL CITIES"
                            })
                        })
                    })
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/components/CityPage/MinorCityPageTemplate.tsx












var MinorCityPageTemplate = function(param) {
    var cityName = param.cityName, state = param.state, cities = param.cities, yelpData = param.yelpData;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Layout/* default */.Z, {
        title: "Brake Repair Near Me in ".concat(cityName, " - NuBrakes Mobile Brake Repair"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                    name: "description",
                    content: "Find brake repair services near me in ".concat(cityName, ", ").concat(state, ". Schedule a brake repair service online in minutes.")
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MinorCityTitleSection, {
                title: "Schedule Affordable Brake Repair in ".concat(cityName, ", ").concat(state),
                subheading: "The most convenient brake repair in ".concat(cityName, " - delivered at your office or home"),
                buttonText: "Get A Free Brake Repair Estimate"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FeatureBySection/* FeatureBySection */.x, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MinorCitySecondSection, {
                firstReasonWhy: {
                    title: "REPAIRS AROUND YOUR SCHEDULE",
                    subheading: "Life’s busy. So why waste your time sitting at a shop? Our brake techs come to you and repair your brakes around your schedule.",
                    icon: faWrench/* faWrench */.kl
                },
                secondReasonWhy: {
                    title: "TRANSPARENT, AFFORDABLE PRICING",
                    subheading: "Our upfront, no-obligation brake repair quotes are designed to give you a transparent view into your vehicle’s repair costs.",
                    icon: pro_duotone_svg_icons/* faHandHoldingUsd */.oFW
                },
                thirdReasonWhy: {
                    title: "HAPPINESS GUARANTEED",
                    subheading: "Our brake techs have decades of combined experience, and all services are backed by our NuBrakes Guarantee.",
                    icon: pro_duotone_svg_icons/* faShieldCheck */.ip0
                },
                subheading: "Our mission is to provide ultra-convenient, transparent brake services in ".concat(cityName, " for less."),
                title: "WE MAKE BRAKE REPAIR SIMPLE IN ".concat(cityName)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ListYelpDataSection, {
                locationName: "".concat(cityName, ", ").concat(state),
                subheading: "Looking for the top-rated brake shop near me in ".concat(cityName, "?"),
                businesses: yelpData
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MinorCityFourthSection, {
                title: "A Better Brake Shop Experience Delivered in Your Driveway.",
                subheading: "Our mobile brake repair technicians provide top-rated, certified brake services from the comfort of your home or office."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(OtherCitiesSection, {
                mainCities: cities
            })
        ]
    });
};
/* harmony default export */ var CityPage_MinorCityPageTemplate = (MinorCityPageTemplate);

// EXTERNAL MODULE: ./src/components/Builder/CodeComponentsRegistration.tsx + 34 modules
var CodeComponentsRegistration = __webpack_require__(32758);
;// CONCATENATED MODULE: ./src/pages/cities/[...cities].tsx










builder_react_es5/* builder.init */.fl.init("ed7f20b509364fd4a7e520373ff39fd7");
var DynamicCityPage = function(props) {
    var router = (0,next_router.useRouter)();
    var builderCities = props.builderCities, cities = props.cities, butterCities = props.butterCities, rating = props.rating, reviewCount = props.reviewCount;
    console.log("[Builder Props]", {
        builderCities: builderCities,
        cities: cities,
        butterCities: butterCities,
        rating: rating,
        reviewCount: reviewCount
    });
    var isBuilder = !!(builderCities || builder_react_es5/* Builder.isEditing */.Ib.isEditing || builder_react_es5/* Builder.isPreviewing */.Ib.isPreviewing);
    var notBulder = !!props.city;
    console.log("[Builder EVAL]", {
        isBuilder: isBuilder,
        notBulder: notBulder
    });
    if (router.isFallback) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingIndicator/* LoadingIndicator */.T, {});
    }
    // Makes it so only the published city pages can be viewed here
    if (builderCities || builder_react_es5/* Builder.isEditing */.Ib.isEditing || builder_react_es5/* Builder.isPreviewing */.Ib.isPreviewing) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: "Brake Repair Near You From NuBrakes"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(builder_react_es5/* BuilderComponent */.VD, {
                    model: "cities",
                    content: cities,
                    data: {
                        butterCities: butterCities,
                        builderCities: builderCities,
                        rating: 2.2,
                        reviewCount: reviewCount
                    }
                })
            ]
        });
    } else if (props.city) {
        var city = props.city, isMajorCity = props.isMajorCity, cities1 = props.cities, rating1 = props.rating, reviewCount1 = props.reviewCount, carsContent = props.carsContent;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CityPost, {
                city: city,
                slug: city.slug,
                isMajorCity: isMajorCity,
                cities: cities1,
                cityName: city.cityName,
                state: city.stateName,
                rating: rating1,
                reviewCount: reviewCount1,
                yelpData: {},
                carsContent: carsContent
            })
        });
    } else {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(_404["default"], {});
    }
};
var CityPost = function(props) {
    var rating = props.rating, reviewCount = props.reviewCount, carsContent = props.carsContent;
    if (props.isMajorCity) {
        var _city = props.city, cityName = _city.cityName, stateAbbreviation = _city.stateAbbreviation, backgroundImage = _city.backgroundImage, listOfZips = _city.listOfZips, listOfMinorCities = _city.listOfMinorCities, phoneNumber = _city.phoneNumber, tags = _city.tags, schemas = _city.schemas, titleTagTitle = _city.titleTagTitle, metaDescription = _city.metaDescription, reviews = _city.reviews, blobSection = _city.blobSection, blobParagraphs = _city.blobParagraphs;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(MajorCityPageTemplate, {
            cities: props.cities,
            phoneNumber: "".concat(phoneNumber),
            titleTagTitle: titleTagTitle,
            metaDescription: metaDescription,
            schemas: schemas,
            rating: rating,
            blobSection: blobSection,
            blobParagraphs: blobParagraphs,
            reviewCount: reviewCount,
            cityName: cityName,
            stateAbbreviation: stateAbbreviation,
            backgroundImage: backgroundImage,
            listOfZips: listOfZips,
            reviews: reviews,
            listOfMinorCities: listOfMinorCities,
            tags: tags,
            carsContent: carsContent
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CityPage_MinorCityPageTemplate, {
        cityName: props.cityName,
        state: props.state,
        rating: props.rating,
        reviewCount: props.reviewCount,
        yelpData: {},
        cities: props.cities
    });
};
var __N_SSG = true;
/* harmony default export */ var _cities_ = (DynamicCityPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [4976,7948,2247,2978,4231,7858,4024,8202,8210,507,2932,6566,6263,7187,9435,2339,9774,2888,179], function() { return __webpack_exec__(42160); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);